module.exports = __webpack_public_path__ + "img/qr-ny.d1228915.png";